
<mat-dialog-content>
  <div style="display: flex;">
    <div style="width: 100%">
      <h1 style="font-size: 1.5rem">User</h1>
    </div>
  
    <lib-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </lib-icon-button>
  </div>
  
  <lib-content-loader *ngIf="loading"></lib-content-loader>
  <div *ngIf="!loading" [formGroup]="form" style="margin-top: 1rem">
    <div >
      <mat-form-field class="full-width" actions appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput type="text" formControlName="first_name">
      </mat-form-field>
    </div>
  
    <div>
      <mat-form-field class="full-width" actions appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" formControlName="last_name">
      </mat-form-field>
    </div>
    
    <div>
      <mat-form-field class="full-width" actions appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="text" formControlName="email_address">
        @if (form.get('email_address')?.hasError('pattern')) {
          <mat-error>
            Please enter a valid email address.
          </mat-error>
        }
      </mat-form-field>
    </div>
    
    @if (profile && [1,2].includes(profile.role_id)) {

      @if (profile && profile.role_id !== 2) {
        <div>
          <mat-form-field class="full-width" actions appearance="outline">
            <mat-label>Organization</mat-label>
            <mat-select formControlName="org_id">
              <mat-option *ngFor="let org of organizations" [value]="org.id">{{ org.name }}</mat-option>  
            </mat-select>
          </mat-form-field>
        </div>
      } @else {
        <div>
          <mat-form-field class="full-width" actions appearance="outline">
            <mat-label>Organization</mat-label>
            <input class="org_input" matInput formControlName="org_name" readonly>
          </mat-form-field>
        </div>
      }
    
        <div>
        <mat-form-field class="full-width" actions appearance="outline">
          <mat-label>Role</mat-label>
          <mat-select formControlName="role_id">
            <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      @if (isSuperSuperAdmin) {
        <div class="ollie-license-row">
          <div class="ollie-badge">
            <img class="ollie-icon" src="assets/ollie-sparkle.svg" alt="Ollie">
          </div>
          <mat-form-field class="full-width" actions appearance="outline">
            <mat-label>License Expiration Date (Ollie)</mat-label>
            <input matInput type="date" formControlName="license_expiration_date">
            @if (hadExistingOllieLicense && form.get('license_expiration_date')?.value) {
              <button
                mat-icon-button
                matSuffix
                type="button"
                aria-label="Remove Ollie license"
                (click)="clearOllieLicense()">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>
        @if (removeOllieLicense) {
          <div class="ollie-remove-warning">
            Removing this license will remove Ollie from this user account when you save.
          </div>
        }
      }

      <div style="padding: 0 0 2rem 0">
        <mat-slide-toggle formControlName="active">Account Status</mat-slide-toggle>
      </div>
    }
  
  </div>
</mat-dialog-content>
<mat-dialog-actions style="gap: 0.8rem; padding: 0 2rem 1rem" align="end">
  <lib-button color="primary" mat-button mat-dialog-close>Close</lib-button>
  <lib-button color="primary" mat-button (click)="saveUser()">Save</lib-button>
</mat-dialog-actions>